import React from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { usePlan } from "@/context/PlanContext";
import { Button } from "@/components/ui/button";

// Subtle, dismissible-free inline banner shown at the top of a screen whose
// feature isn't in the tenant's plan (free trial / Basic). Converts better than
// a one-off 402 toast because the value prop is always visible.
export default function UpgradeBanner({ feature, title, children, className = "" }) {
  const { has, loading } = usePlan();
  const navigate = useNavigate();
  if (loading || has(feature)) return null;
  return (
    <div
      data-testid={`upgrade-banner-${feature}`}
      className={`flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-200 bg-gradient-to-r from-amber-50 to-white px-4 py-3 ${className}`}
    >
      <div className="flex items-start gap-3">
        <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-600">
          <Sparkles className="h-4 w-4" />
        </span>
        <div className="min-w-0">
          <p className="text-sm font-semibold text-slate-800">{title || "Upgrade to unlock"}</p>
          <p className="text-xs text-slate-500">{children}</p>
        </div>
      </div>
      <Button
        size="sm"
        variant="outline"
        className="border-amber-300 text-amber-700 hover:bg-amber-100"
        onClick={() => navigate("/settings?tab=subscription")}
        data-testid={`upgrade-banner-cta-${feature}`}
      >
        View plans <ArrowRight className="ml-1.5 h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
